import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './customDatePicker.css'; // Import custom CSS file

const MyDatePicker = () => {
  const [selectedDate, setSelectedDate] = useState(null);

  const handleChange = date => {
    setSelectedDate(date);
  };

  return (
    <div>
      <DatePicker
        selected={selectedDate}
        onChange={handleChange}
        dateFormat="dd/MM/yyyy"
        isClearable
        placeholderText="Select a date"
      />
    </div>
  );
};

export default MyDatePicker;
